<div class="form-group">
  @if (label?.length) {
    <label class="d-flex justify-content-between">
      <span class="inline-flex-gap-5 align-items-center">
        {{ label | translate }}
        @if (tooltipLabel?.length) {
          <info-tooltip [label]="tooltipLabel" [icon]="tooltipIcon"></info-tooltip>
        }
      </span>
      @if (required) {
        <label class="float-right required"> ({{ 'required' | translate }}) </label>
      }
    </label>
  }
  <div
    class="digit-boxes"
    role="group"
    [attr.aria-label]="label | translate"
    [class.is-invalid]="showInvalid"
    [attr.data-cy]="dataCyAttribute"
    [attr.data-value]="value"
    (focusin)="hasFocus = true"
    (focusout)="onFocusOut($event)"
  >
    @for (box of boxes; track box) {
      <input
        #digitInput
        class="form-control digit-box"
        [class.is-invalid]="showInvalid"
        type="text"
        inputmode="numeric"
        autocomplete="off"
        [attr.tabindex]="box === activeIndex ? 0 : -1"
        [attr.aria-label]="(label | translate) + ' ' + (box + 1) + '/' + length"
        [attr.data-cy]="dataCyAttribute ? dataCyAttribute + '-digit' : null"
        (focus)="onFocus(box)"
        (input)="onInput(box, $event)"
        (keydown)="onKeydown(box, $event)"
      />
    }
  </div>
  @if (showInvalid && errorLabel) {
    <div class="invalid-feedback d-block" [attr.data-cy]="dataCyAttribute ? dataCyAttribute + '-error' : null">
      {{ errorLabel | translate }}
    </div>
  }
</div>
